<template>
  <div>
    <slot name="header" />
    <div class="flex-1 relative md:overflow-y-auto border-gray-100">
      <saving-overlay v-if="loading" opacity="10" text-color="text-gray-700" />
      <div v-if="hasItems">
        <fade-transition
          group
          :duration="{ enter: 400, leave: 50 }"
          v-if="hasItems"
        >
          <div
            v-for="item in items"
            :key="item.id"
            class="border-gray-100 border-r border-l border-b first:border-t first:rounded-t last:rounded-b"
          >
            <!-- //@todo allow key definition by params -->
            <slot name="item" :item="item">{{ item }}</slot>
          </div>
        </fade-transition>
      </div>
      <div
        class="flex justify-between items-center"
        v-if="!hasItems && !loading"
      >
        <slot name="empty" />
      </div>
    </div>
    <paginator
      v-if="showPaginator"
      class="py-2"
      :links="paginator.links"
      :meta="paginator.meta"
      :limit="3"
      :plural-name="pluralName"
      @page-changed="pageChanged"
      @perpage-changed="perpageChanged"
    ></paginator>
  </div>
</template>

<script>
import Paginator from "../Commons/Paginator";
import { FadeTransition } from "vue2-transitions";

export default {
  props: ["title", "paginator", "action", "item", "loading", "pluralName"],
  components: { Paginator, FadeTransition },
  methods: {
    pageChanged(page) {
      this.dispatch(this.paginator.meta.per_page, page);
    },
    perpageChanged(per_page) {
      const skippedItems =
        (this.paginator.meta.current_page - 1) * this.paginator.meta.per_page;
      let page = Math.round(skippedItems / per_page) + 1;
      const last_page = Math.ceil(this.paginator.meta.total / per_page);
      page = Math.min(page, last_page);
      this.dispatch(per_page, page);
    },
    dispatch(per_page, page) {
      let queryString = "per_page=" + per_page + "&page=" + page;
      if (this.paginator.meta.query) {
        queryString += "&" + this.paginator.meta.query;
      }

      this.$store.dispatch(this.action, queryString);
    },
  },
  computed: {
    items() {
      if (this.paginator.meta.per_page) {
        return this.paginator.data.slice(0, this.paginator.meta.per_page);
      }

      return this.paginator.data;
    },

    hasItems() {
      return this.paginator.data.length > 0;
    },

    showPaginator() {
      if (this.paginator.links === undefined) {
        return false;
      }

      if (this.paginator.meta.per_page === undefined) {
        return false;
      }

      return this.hasItems;
    },
  },
  mounted() {
    this.$emit("load-data");
  },
};
</script>
